// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--ZilU1","title":"_02712f2b3b--title--wLOT4","title-icon":"_02712f2b3b--title-icon--KFgq7"};